module.exports = __webpack_public_path__ + "img/logout.2601cf31.svg";